import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  CreateOrganizationFailure,
  CreateOrganizationRequest,
  CreateOrganizationSuccess,
  DeleteOrganizationFailure,
  DeleteOrganizationRequest,
  DeleteOrganizationSuccess,
  FetchOrganizationFailure,
  FetchOrganizationRequest,
  FetchOrganizationSuccess,
  FetchOrganizationsFailure,
  FetchOrganizationsRequest,
  FetchOrganizationsSuccess,
  UpdateOrganizationFailure,
  UpdateOrganizationRequest,
  UpdateOrganizationSuccess,
} from './organizations.actions'
import { OrganizationsService } from './organizations.service'
import * as Organizations from './organizations.types'

@Injectable()
export class OrganizationsEffects {
  constructor(
    private actions: Actions,
    private OrganizationsService: OrganizationsService,
    private router: Router,
  ) {}

  FetchOrganizations$ = createEffect(() =>
    this.actions.pipe(
      ofType(Organizations.FETCH_ORGANIZATIONS_REQUEST),
      switchMap((action: FetchOrganizationsRequest) => {
        return this.OrganizationsService.fetchOrganizations(
          action.payload,
        ).pipe(
          map((result) => {
            return new FetchOrganizationsSuccess(
              result.data.results,
              result.data.totalCount,
              result.data.filteredCount,
            )
          }),
          catchError((err, caught) => {
            return of(new FetchOrganizationsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchOrganization$ = createEffect(() =>
    this.actions.pipe(
      ofType(Organizations.FETCH_ORGANIZATION_REQUEST),
      switchMap((action: FetchOrganizationRequest) => {
        return this.OrganizationsService.fetchOrganization(action.id).pipe(
          map((result) => {
            return new FetchOrganizationSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchOrganizationFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteOrganization$ = createEffect(() =>
    this.actions.pipe(
      ofType(Organizations.DELETE_ORGANIZATION_REQUEST),
      switchMap((action: DeleteOrganizationRequest) => {
        return this.OrganizationsService.deleteOrganization(action.id).pipe(
          switchMap((result) => {
            return [new DeleteOrganizationSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteOrganizationFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateOrganization$ = createEffect(() =>
    this.actions.pipe(
      ofType(Organizations.CREATE_ORGANIZATION_REQUEST),
      switchMap((action: CreateOrganizationRequest) => {
        return this.OrganizationsService.createOrganization(
          action.payload,
        ).pipe(
          switchMap((result) => {
            this.router.navigate(['/admin/registrations'])
            return [new CreateOrganizationSuccess()]
          }),
          catchError((err, caught) => {
            return of(new CreateOrganizationFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateOrganization$ = createEffect(() =>
    this.actions.pipe(
      ofType(Organizations.UPDATE_ORGANIZATION_REQUEST),
      switchMap((action: UpdateOrganizationRequest) => {
        return this.OrganizationsService.updateOrganization(
          action.id,
          action.payload,
        ).pipe(
          switchMap((result) => {
            this.router.navigate(['/admin/registrations'])
            return [new UpdateOrganizationSuccess()]
          }),
          catchError((err, caught) => {
            return of(new UpdateOrganizationFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
